import useResourceParams from '@kanrisha/composables/useResourceParams';
import { ref } from 'vue';

export default function useActionButtons(props, bulkSelected = () => {}) {
  const { getPickedParams } = useResourceParams(props);
  const meta = ref(props.meta ?? null);
  const actionButtons = {};

  const getActionButtons = (model, route, routePrefix) => {
    let localMeta = meta.value ?? model.meta;

    if (localMeta.config.actions.models.show) {
      addShowButton();
    }
    if (localMeta.config.actions.models.edit) {
      addEditButton(model, route, routePrefix);
    }
    if (localMeta.config.actions.models.delete) {
      addDeleteButton(model);
    }

    return actionButtons;
  };

  const addShowButton = () => {
    if (!props.mode?.includes('dashboard')) {
      actionButtons['show'] = { iconClass: 'bi bi-eye-fill' };
    }
  };

  const addEditButton = (model, route, routePrefix) => {
    let localMeta = meta.value ?? model.meta;
    if (props.mode === 'dashboard') {
      actionButtons['dashboard'] = { iconClass: 'bi bi-pencil-square' };
    } else if (props.mode === 'dashboard-component' && localMeta.relationInfo.relationType !== 'belongsToMany') {
      actionButtons['pick'] = {
        iconClass: 'bi bi-pencil-square',
        target: route(
          `${routePrefix}.${props.options.parentResource.meta.resourceType}.adjust`,
          getPickedParams(props.options.parentResource, model)
        ),
        relation: localMeta.relationInfo?.name,
      };
    } else if (!bulkSelected() && !props.mode?.includes('dashboard')) {
      actionButtons['edit'] = { iconClass: 'bi bi-pencil-square' };
    } else if (bulkSelected() && !props.mode?.includes('dashboard')) {
      actionButtons['edit'] = { iconClass: 'bi bi-pencil-square', disabled: true };
    }
  };

  const addDeleteButton = (model) => {
    let localMeta = meta.value ?? model.meta;
    actionButtons['destroy'] = {
      iconClass: 'bi bi-trash fs-5',
      confirm: {
        translation: {
          text: `models.${localMeta.resourceType}.content.delete.confirmation`,
          params: { instanceTitle: model.data.id },
        },
      },
    };
  };

  return {
    getActionButtons,
  };
}
